var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdfIcon = function SvgPdfIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#pdfIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9FBFF",
    d: "M4 5.475A3.475 3.475 0 0 1 7.475 2H24l7.177 8.518c.531.63.821 1.429.818 2.253l-.069 17.767A3.475 3.475 0 0 1 28.452 34H7.475A3.475 3.475 0 0 1 4 30.525z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24 2 8 9.495h-4.525A3.475 3.475 0 0 1 24 8.018z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A68FF",
    d: "M26.437 18.15v.618h-3.47V22h-.641v-7H27v.618h-4.032v2.532zm-6.43-2.205q.968.945.968 2.555t-.968 2.555q-.958.945-2.5.945h-2.152v-7h2.151q1.543 0 2.5.945m-2.523-.327h-1.487v5.764h1.487q1.227 0 2.027-.782.81-.782.811-2.1 0-1.319-.811-2.1-.8-.782-2.027-.782M9 22v-7h2.59q1.195 0 1.87.618.675.607.676 1.692 0 1.132-.698 1.773-.687.63-1.881.63H9.642V22zm4.494-4.667q0-.828-.518-1.271-.518-.444-1.397-.444H9.642v3.477h1.937q.89 0 1.397-.443.518-.455.518-1.319"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pdfIcon_svg__a",
    width: 35.995,
    height: 40,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.164706 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_191_6051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_191_6051",
    result: "shape"
  })))));
};
export { SvgPdfIcon as ReactComponent };